// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"b2f4d15c","508":"6fe77d4e","776":"fbb902bb"}[chunkId] + ".chunk.js";
};